import React from 'react';

const TileDivider = ({ className = "" }) => {
  return (
    <div className={`flex items-center justify-center space-x-4 ${className}`}>
      <div className="h-px bg-padua-gold/30 w-16 sm:w-24"></div>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-padua-gold opacity-80">
        <path d="M12 2L14.4 9.6H22L15.8 14.4L18.2 22L12 17.2L5.8 22L8.2 14.4L2 9.6H9.6L12 2Z" fill="currentColor" opacity="0.5"/>
        <circle cx="12" cy="12" r="3" fill="currentColor"/>
      </svg>
      <div className="h-px bg-padua-gold/30 w-16 sm:w-24"></div>
    </div>
  );
};

export default TileDivider;